<script>
  // import { mapState } from 'vuex'
  export default {
    name: 'AutocompleteSelect',
    props: ['form', 'placeholder', 'rules', 'field', 'label', 'items'],
    computed: {
      model: {
        get() {
          return this.$store.state[this.form][this.field]
        },
        set(v) {
          this.$store.dispatch(`${ this.form }/SET_FIELD`, { key: this.field, value: v })
        },
      },
    },
  }
</script>

<template>
  <v-radio-group :rules="rules" class="mt-0" v-model="model" :label="label" :placeholder="placeholder">
    <v-radio v-for="item in items" :key="item.value" :label="item.name" :value="item.value"></v-radio>
  </v-radio-group>
</template>
